import { Autocomplete, Box, Button, FormControl, IconButton, InputAdornment, InputLabel, Menu, MenuItem, Paper, Select, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Tooltip, Typography } from '@mui/material'
import React, { Component } from 'react'
import { withTranslation } from 'react-i18next';
import CommonValidation from '../../Components/CommonFunctions/CommonValidation';
import { Colors } from '../../Styles/Colors';
import RestAPIService from '../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../Utility/API/Serviceurls';
import { getCachevalue, localGetItem, setCachevalue } from '../../Utility/Services/CacheProviderService';
import ToastMsg from '../../Components/ToastMsg/ToastMsg';
import { CommonPatientCard, CommonPatientDetails, ConsultantPatientCard } from '../../Components/Common Components/CommonComponents';
import { ImagePaths } from '../../Utility/ImagePaths';


class SurgeonDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            SurgeonOne: "",
            SurgeonTwo: "",
            SurgeonThree: "",
            Technician: "",
            Assistant: "",
            JrAnaesthetist: "",
            anaesthesia_type: "",
            Duration: "",
            durationType: "Hours",
            BloodRequirement: "",
            Notes: "",
            ClinicID: null,
            DoctorData: [],
            OTpatientData: null,
            ot_id: null,
            OTDetails: [],
            NurseList: [],
            Tec_Ana_List: [],
            anesthesiest:[]
        }
    }

    componentDidMount = () => {
        var myUser = JSON.parse(localGetItem("loggedInUserInfo"))
        let Data = JSON.parse(getCachevalue("OTSurgeonData")) ? JSON.parse(getCachevalue("OTSurgeonData")) : JSON.parse(getCachevalue("OTpatientData"))
        var clinic_id = myUser?.clinic_id ? myUser?.clinic_id : localGetItem("SelectedDoctorClinicId") ? localGetItem("SelectedDoctorClinicId") : null
        var OTID = JSON.parse(getCachevalue("OTpatientData"))
        if (clinic_id) {
            this.setState({
                ClinicID: clinic_id,
                OTpatientData: Data?.additional_detail,
                ot_id: OTID?.id
            }, () => {
                this.getDoctorList()
            })
        }
        if (myUser?.module_name === "ot_management") {
            let patientDatas = getCachevalue("OTpatientData")
            let patients = JSON.parse(patientDatas)
            this.setState({
                OTDetails: patients
            })
        }
    }

    getDoctorList = () => {
        try {
            RestAPIService.getAll(Serviceurls.HOME_GET_CLINIC_DOCTORS + "?clinic_id=" + this.state.ClinicID).
                then((response) => {
                    if (response.data.status === "success") {
                        let data = response.data.data?.length > 0 ? JSON.parse(JSON.stringify(response.data.data)) : []
                        data?.unshift({ initial: 'N/A', title: '', doctor_id: null })
                        this.setState({
                            DoctorData: response.data.data,
                            anesthesiest: data
                        }, () => {
                            this.getNurseList()
                        })
                    }
                    else {
                        this.errorMessage(response.data.message)
                    }
                }).catch((error) => {
                    this.errorMessage(error.message)
                })
        } catch (e) {
            this.errorMessage(e.message)
        }
    }

    getNurseList = () => {
        try {
            RestAPIService.getAll(Serviceurls.FO_STAFF_LIST + "?clinic_id=" + this.state.ClinicID).
                then((response) => {
                    if (response.data.status === "success") {
                        this.setState({
                            NurseList: response.data.data,
                        },()=>{
                            if(this.state.DoctorData.length > 0){
                                let TecList =this.state.DoctorData.concat(response.data.data)
                                this.setState({
                                    Tec_Ana_List: TecList
                                },()=>{this.assigndata()})
                            }else{
                                this.setState({
                                    Tec_Ana_List: response.data.data
                                },()=>{this.assigndata()})
                            }
                        })
                    }
                    else {
                        this.errorMessage(response.data.message)
                    }
                }).catch((error) => {
                    this.errorMessage(error.message)
                })
        } catch (e) {
            this.errorMessage(e.message)
        }
    }
    assigndata = () => {
        this.setState({
            SurgeonOne: this.state?.OTpatientData?.surgeon1,
            SurgeonTwo: this.state?.OTpatientData?.surgeon2,
            SurgeonThree: this.state?.OTpatientData?.surgeon3,
            JrAnaesthetist: this.state?.OTpatientData?.JrAnaesthetist,
            anaesthesia_type: this.state?.OTpatientData?.anaesthesia_type,
            Duration: this.state?.OTpatientData?.Duration,
            durationType: this.state?.OTpatientData?.durationType ? this.state?.OTpatientData?.durationType : "Hours",
            BloodRequirement: this.state?.OTpatientData?.BloodRequirement,
            Notes: this.state?.OTpatientData?.Notes
        },()=>{
            let tech = '';
            let assis = '';

            if (this.state?.OTpatientData?.Technician) {
                tech = this.state.DoctorData.find((item) => (
                    item.doctor_id === this.state?.OTpatientData?.Technician
                ));
            } else {
                tech = this.state.NurseList.find((item) => (
                    item.staff_id === this.state?.OTpatientData?.Technician_nurse
                ));
            }

            if (this.state?.OTpatientData?.Assistant) {
                assis = this.state.DoctorData.find((item) => (
                    item.doctor_id === this.state?.OTpatientData?.Assistant
                ));
            } else {
                assis = this.state.NurseList.find((item) => (
                    item.staff_id === this.state?.OTpatientData?.Assistant_nurse
                ));
            }
            this.setState({
                Technician: tech,
                Assistant: assis
            });
        })
    }
    PostSurgeonDetails = () => {
        try {
            let Data = {
                id: this.state.ot_id,
                additional_detail: {
                    "surgeon1": this.state.SurgeonOne,
                    "surgeon2": this.state.SurgeonTwo,
                    "surgeon3": this.state.SurgeonThree,
                    "Technician": this.state.Technician?.doctor_id ? this.state.Technician?.doctor_id : null,
                    "Technician_nurse": this.state.Technician?.staff_id ? this.state.Technician?.staff_id : null,
                    "Assistant_nurse": this.state.Assistant?.staff_id ? this.state.Assistant?.staff_id : null,
                    "Assistant": this.state.Assistant?.doctor_id ? this.state.Assistant?.doctor_id : null,
                    "JrAnaesthetist": this.state.JrAnaesthetist,
                    "anaesthesia_type": this.state.anaesthesia_type,
                    "Duration": this.state.Duration,
                    "durationType": this.state.durationType,
                    "BloodRequirement": this.state.BloodRequirement,
                    "Notes": this.state.Notes
                }
            }
            RestAPIService.updateWithOutId(Data, Serviceurls.DOC_OT_REQUEST_GET)
                .then((response) => {
                    if (response.data.status === 'success') {
                        this.successMessage(response.data.message)
                        setCachevalue(JSON.stringify(Data), "OTSurgeonData");
                    }
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        this.errorMessage(error.response.data.message)
                    } else {
                        this.errorMessage(error.message)
                    }
                })
        } catch (e) {
            this.errorMessage(e.message)
        }
    }

    errorMessage = (message) => {
        this.setState({
            isErrorMsg: true,
            isErrorMsgText: message
        })
    }

    successMessage = (message) => {
        this.setState({
            successMsg: true,
            successMsgText: message
        })
    }

    msgClose() {
        this.setState({
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: ''
        })
    }

    ClearData = () => {
        this.setState({
            SurgeonOne: "",
            SurgeonTwo: "",
            SurgeonThree: "",
            Technician: "",
            Assistant: "",
            JrAnaesthetist: "",
            anaesthesia_type: "",
            Duration: "",
            durationType: "Hours",
            BloodRequirement: "",
            Notes: ""
        })
    }

    renderTextInput = (Title, value, key) => {
        let states = this.state
        const fieldTid = key.replace(/([A-Z])/g, '_$1').toLowerCase();
        const renderMenuItems = () => {
            if (key === "Technician" || key === "Assistant") {
              if (states?.Tec_Ana_List?.length > 0) {
                return states?.Tec_Ana_List.map((item, index) => (
                  <MenuItem key={index} value={item} emed_tid={`surgeon_details_${fieldTid}_option_${index}`}>
                    {item?.staff_id 
                      ? item.nurse || "" 
                      : `${item.title || ""} ${item.initial || ""} ${item.first_name || ""}`}
                  </MenuItem>
                ));
              } else if (states?.DoctorData?.length > 0) {
                return states?.DoctorData.map((item, index) => (
                  <MenuItem key={index} value={item} emed_tid={`surgeon_details_${fieldTid}_option_${index}`}>
                    {`${item.title || ""} ${item.initial || ""} ${item.first_name || ""}`}
                  </MenuItem>
                ));
              }
            }else{
                if(Title === 'Jr Anaesthetist'){
                    return states?.anesthesiest?.map((item,index) => (
                        <MenuItem key={index} value={item?.doctor_id ? item?.doctor_id : item?.initial} emed_tid={`surgeon_details_${fieldTid}_option_${index}`}>
                      {`${item.title || ""} ${item.initial || ""} ${item.first_name || ""}`}
                    </MenuItem>
                    ))
                }else{
                    return states?.DoctorData.map((item, index) => (
                        <MenuItem key={index} value={item?.doctor_id} emed_tid={`surgeon_details_${fieldTid}_option_${index}`}>
                          {`${item.title || ""} ${item.initial || ""} ${item.first_name || ""}`}
                        </MenuItem>
                      ));
                }
            }
            return null;
          };
        return (
            <FormControl size='small' style={{ width: '18vw', margin: "0.65vw" }} emed_tid={`surgeon_details_${fieldTid}_form`}>
                <InputLabel emed_tid={`surgeon_details_${fieldTid}_label`}>{Title}</InputLabel>
                <Select
                    value={value ? value : ""}
                    label={Title}
                    emed_tid={`surgeon_details_${fieldTid}_select`}
                    onChange={(event) => {
                        states[key] = event.target.value;
                        this.setState({
                            states
                        })
                    }}
                    MenuProps={{
                        style: { maxHeight: 350 },
                    }}
                >
                    <MenuItem value={""} emed_tid={`surgeon_details_${fieldTid}_option_empty`}>{"Select"}</MenuItem>
                    {renderMenuItems()}
                </Select>
            </FormControl>
        )
    }

    renderNurseNotesHeader = () => {
        const { t } = this.props
        let vital_attender_data = {
            lineOne: t("AttenderName"),
            lineTwo: `${this.state.vital_attender_name ? this.state.vital_attender_name : this.state.OTDetails.attender_name ? this.state.OTDetails.attender_name : "-"}`,
            lineFour: t('ContactNumber'),
            LineFive: `${this.state.vital_attender_mobile ? this.state.vital_attender_mobile : this.state.OTDetails.attender_mobile ? this.state.OTDetails.attender_mobile : "-"}`
        }
        let vital_doctor_data = {
            image: ImagePaths.Doctor_Icon.default,
            height: "2.3vw",
            width: "2.3vw",
            lineOne: t("ConsultantName"),
            lineTwo: `${this.state.vital_doctor_name ? this.state.vital_doctor_name : this.state.OTDetails.admitting_consultant ? this.state.OTDetails.admitting_consultant : "-"}`
        }
        return (
            <Box display={'flex'} emed_tid="surgeon_details_header">
                <Box className='eMed_nur_notes_details' emed_tid="surgeon_details_patient_details">
                    {
                        <CommonPatientDetails data={this.state.OTDetails} emed_tid="surgeon_details_patient_details_component" />
                    }
                </Box>
                {
                    <>
                        <CommonPatientCard details={vital_attender_data} showDetailed={true} emed_tid="surgeon_details_attender_card" />
                        <ConsultantPatientCard name={vital_doctor_data} emed_tid="surgeon_details_consultant_card" />
                    </>
                }
            </Box>
        )
    }

    render() {
        const { t } = this.props;
        let states = this.state
        return (
            <Stack component={"div"} style={{ marginTop: "1vw" }} emed_tid="surgeon_details_container">
                <Box component={'div'} sx={{height:"5vw"}} emed_tid="surgeon_details_header_box">
                    {this.renderNurseNotesHeader()}
                </Box>
                <Paper emed_tid="surgeon_details_paper">
                    <Box sx={{ height: "50vh" }} emed_tid="surgeon_details_content_box">
                        <Box component={'div'} emed_tid="surgeon_details_title_box">
                            <Typography style={{ backgroundColor: "#ffffff", borderBottom: "1px solid #D3D3D3" }} className='eMed_refdoc_title' emed_tid="surgeon_details_title">{t("OT Details")}</Typography>
                        </Box>
                        <Box emed_tid="surgeon_details_sections">
                            <Box emed_tid="surgeon_details_ot_team_section">
                                <Typography style={{ height: "4vh", color: "#616161", paddingLeft: "1vw", fontWeight: "600", display: "flex", alignItems: "center", marginTop: "0.5vw", fontSize: "0.85vw" }} emed_tid="surgeon_details_ot_team_label">{t("OT Team")}</Typography>
                                <div style={{ display: "flex", flexDirection: 'row', alignItems: "center", justifyContent: "space-between" }} emed_tid="surgeon_details_ot_team_fields">
                                    {this.renderTextInput("Assistant Surgeon 1", this.state.SurgeonOne, "SurgeonOne")}
                                    {this.renderTextInput("Assistant Surgeon 2", this.state.SurgeonTwo, "SurgeonTwo")}
                                    {this.renderTextInput("Assistant Surgeon 3", this.state.SurgeonThree, "SurgeonThree")}
                                    {this.renderTextInput("OT Technician", this.state.Technician, "Technician")}
                                    {this.renderTextInput("OT Assistant", this.state.Assistant, "Assistant")}
                                </div>
                            </Box>
                            <Box emed_tid="surgeon_details_anaesthetist_section">
                                <Typography style={{ height: "4vh", color: "#616161", paddingLeft: "1vw", fontWeight: "600", display: "flex", alignItems: "center", marginTop: "0.5vw", fontSize: "0.85vw" }} emed_tid="surgeon_details_anaesthetist_label">{t("Anaesthetist Deatils")}</Typography>
                                <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }} emed_tid="surgeon_details_anaesthetist_fields">
                                    {this.renderTextInput("Jr Anaesthetist", this.state.JrAnaesthetist, "JrAnaesthetist")}
                                    <TextField
                                        inputProps={{ maxLength: 30 }}
                                        sx={{ width: "18vw", marginLeft: "1vw" }}
                                        size='small'
                                        label={"Anaesthesia Type"}
                                        value={this.state.anaesthesia_type}
                                        autoComplete="off"
                                        emed_tid="surgeon_details_anaesthesia_type_input"
                                        onChange={(e) => {
                                            this.setState({
                                                anaesthesia_type: e.target.value
                                            })
                                        }}
                                    />
                                    <div style={{ display: "flex", flexDirection: "row", width: "35%", marginLeft: "1vw" }} emed_tid="surgeon_details_duration_container">
                                        <TextField
                                            size='small'
                                            sx={{ width: '12vw' }}
                                            value={this.state.Duration}
                                            label='Approx Duration'
                                            emed_tid="surgeon_details_duration_input"
                                            onChange={(e) => {
                                                let isValid = CommonValidation.numberOnly(e.target.value)
                                                if (isValid || e.target.value == "") {
                                                    this.setState({ Duration: e.target.value })
                                                }
                                            }}
                                        />
                                        <FormControl sx={{ width: "8vw", marginLeft: "-0.1vw" }} emed_tid="surgeon_details_duration_type_form">
                                            <Select
                                                value={this.state.durationType}
                                                onChange={(event) => { this.setState({ durationType: event.target.value }) }}
                                                displayEmpty
                                                inputProps={{ 'aria-label': 'Without label' }}
                                                size='small'
                                                emed_tid="surgeon_details_duration_type_select"
                                            >
                                                <MenuItem value="Hours" emed_tid="surgeon_details_duration_type_option_hours">Hours</MenuItem>
                                                <MenuItem value="Minutes" emed_tid="surgeon_details_duration_type_option_minutes">Minutes</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </div>
                                </div>
                            </Box>
                            <Box emed_tid="surgeon_details_other_section">
                                <Typography style={{ height: "4vh", color: "#616161", paddingLeft: "1vw", fontWeight: "600", display: "flex", alignItems: "center", marginTop: "0.5vw", fontSize: "0.85vw" }} emed_tid="surgeon_details_other_label">{t("Other Details")}</Typography>
                                <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }} emed_tid="surgeon_details_other_fields">
                                    <div style={{ marginLeft: "1vw" }} emed_tid="surgeon_details_blood_requirement_container">
                                        <TextField
                                            inputProps={{ maxLength: 300 }}
                                            className='eMed_small_textFields'
                                            sx={{ width: "22vw" }}
                                            size='small'
                                            label={"Blood Requirements made By"}
                                            value={this.state.BloodRequirement}
                                            autoComplete="off"
                                            emed_tid="surgeon_details_blood_requirement_input"
                                            onChange={(e) => {
                                                this.setState({
                                                    BloodRequirement: e.target.value
                                                })
                                            }}
                                        />
                                    </div>
                                    <TextField
                                        inputProps={{ maxLength: 300 }}
                                        className='eMed_small_textFields'
                                        style={{ width: "22vw", marginLeft: "1vw" }}
                                        size='small'
                                        label={"Notes"}
                                        value={states?.Notes}
                                        emed_tid="surgeon_details_notes_input"
                                        onChange={(e) => {
                                            states.Notes = e.target.value
                                            this.setState({
                                                states
                                            })
                                        }}
                                        autoComplete="off"
                                    />
                                </div>
                            </Box>
                        </Box>
                    </Box>
                    <Stack spacing={2} direction="row" alignItems="center" justifyContent="flex-end" height={"6vh"} marginTop={"1vw"} marginRight={"3vw"} emed_tid="surgeon_details_footer">
                        <Button variant='outlined' size="small" id="eMed_Config_btn" onClick={() => { this.ClearData() }} emed_tid="surgeon_details_clear_btn">{t("Clear")}</Button>
                        <Button variant='contained' size="small" id="eMed_Config_btn" onClick={() => { this.PostSurgeonDetails() }} emed_tid="surgeon_details_save_btn">{t("Save")}</Button>
                    </Stack>
                </Paper>
                {this.state.isErrorMsg ?
                    <ToastMsg
                        severity={'error'}
                        msg={this.state.isErrorMsgText}
                        msgPop={this.msgClose.bind(this)}
                        emed_tid="surgeon_details_error_toast"
                    />
                    : null}
                {this.state.successMsg ?
                    <ToastMsg
                        severity={'success'}
                        msg={this.state.successMsgText}
                        msgPop={this.msgClose.bind(this)}
                        emed_tid="surgeon_details_success_toast"
                    />
                    : null}
            </Stack>
        )
    }
}
export default withTranslation()(SurgeonDetails)